<div layout-right>
  <nav mat-tab-nav-bar class="bdz-nav" [tabPanel]="tabPanel" [mat-stretch-tabs]="false">
    @for (tab of dashboardTabs; track tab) {
      <a
        mat-tab-link
        routerLinkActive
        #rla="routerLinkActive"
        queryParamsHandling="merge"
        [routerLink]="tab.path"
        [active]="rla.isActive"
        class="bdz-tab"
      >
        <mat-icon>{{ tab.icon }}</mat-icon>
        <span>{{ tab.label | transloco }}</span>
      </a>
    }
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>

  <!-- router outlet -->
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>
